/* bundle precompilado (generado) */
(function(){
"use strict";

/* ===== rk-data-live.jsx ===== */
/* Redi Food — "Armá tu kit" · data layer CONECTADO (modelo curado por slot)
   Lee window.RK_CATALOG (inyectado por la section Liquid). v2: menús curados
   por almuerzo. Cada almuerzo = 1 proteína + acompañamiento 1 + acompañamiento 2,
   elegidos SOLO entre las opciones que Redi dispuso para ese slot (control de
   costo/inventario). Las opciones difieren entre Kit 5 y Kit 7 y entre slots.

   Forma del catálogo:
     sizes:  [{key, n, price, compare, tagline, label, popular, kitVariantId, kitDraft}]
       · key = id único del kit ('5','7','14','premium'); n = nº de almuerzos.
         Se separan porque dos kits pueden tener el mismo nº de almuerzos pero
         menú distinto (p. ej. Kit 5 vs Premium, ambos de 5).
     dishes: { <id>: {id, name, image, tone, variantId, status, draft, kind} }
     menus:  { <key>:[ {proteins:[ids], acomp1:[ids], acomp2:[ids]}, …n ] } */

const money = n => '$' + Math.round(n).toLocaleString('es-CO');
const RK_CATALOG = window.RK_CATALOG || {
  sizes: [],
  dishes: {},
  menus: {}
};

/* ---- Kits (solo los que traen menú curado). Keyados por `key` (no por n). ---- */
const keyOf = s => String(s.key != null ? s.key : s.n);
// Etiquetas por tipo de kit: 'full' = almuerzo (proteína + 2 acomp); 'single' = una
// sola selección por unidad (proteína suelta o batido). Gobierna el copy del wizard.
const unitFor = s => {
  if (s.shape !== 'single') return {
    one: 'almuerzo',
    many: 'almuerzos',
    short: 'Alm.',
    art: 'el',
    build: 'Elige 1 proteína y 2 acompañamientos.'
  };
  return s.pick === 'batido' ? {
    one: 'batido',
    many: 'batidos',
    short: 'Batido',
    art: 'el',
    build: 'Elige tu batido.'
  } : {
    one: 'proteína',
    many: 'proteínas',
    short: 'Prot.',
    art: 'la',
    build: 'Elige tu proteína.'
  };
};
const RK_SIZES = RK_CATALOG.sizes.filter(s => RK_CATALOG.menus && RK_CATALOG.menus[keyOf(s)]).map(s => ({
  key: keyOf(s),
  n: s.n,
  price: s.price,
  compare: s.compare,
  tagline: s.tagline,
  label: s.label || 'Kit ' + s.n,
  popular: !!s.popular,
  premium: !!s.premium,
  kitVariantId: s.kitVariantId,
  kitDraft: !!s.kitDraft,
  shape: s.shape || 'full',
  pick: s.pick || 'protein',
  unit: unitFor(s),
  image: s.image || null // foto del producto kit (tarjeta grande del paso 1)
}));
// Acepta key ('premium') o, por compatibilidad, el nº de almuerzos.
const sizeOf = k => RK_SIZES.find(s => s.key === String(k)) || RK_SIZES.find(s => s.n === k) || RK_SIZES[0];
// Forma del kit ('full' | 'single'). Decide la UI de armado y la regla de "completo".
const shapeOf = k => (sizeOf(k) || {}).shape || 'full';

/* ---- Diccionario de platos (proteínas + acompañamientos) por id ---- */
const RK_DISHES = RK_CATALOG.dishes || {};
const dishById = id => id == null ? null : RK_DISHES[String(id)] || null;
const DISH_BY = RK_DISHES; // alias de compatibilidad

/* ---- Menús curados por kit (key) y slot ---- */
const RK_MENUS = RK_CATALOG.menus || {};
const menuFor = (kit, slot) => RK_MENUS[kit] && RK_MENUS[kit][slot] || {
  proteins: [],
  acomp1: [],
  acomp2: []
};

/* ---- Dos niveles de validez de un plato:
   · SELECCIONABLE: existe como opción real del menú (no es un placeholder en
     borrador). Es lo que decide si el usuario puede elegirlo en el wizard. En modo
     kit-only el carrito agrega solo el Kit, así que basta con que el plato exista.
   · COMPRABLE: además tiene variante real, ACTIVE y publicada → puede convertirse en
     línea de /cart/add.js. Solo relevante en modo 'kit+components' (evita que un
     componente no vendible rompa el lote atómico del carrito).
   Los NO seleccionables (draft / por crear en inventario) se muestran "Próximamente". ---- */
const dishSelectable = d => !!d && !d.draft;
// COMPRABLE = línea válida de /cart/add.js (modo 'kit+components'). Además de variante
// real + ACTIVE + no draft, debe estar PUBLICADO al canal Online Store: una variante no
// publicada hace que Shopify rechace TODO el lote atómico ("no se encontró la variante").
// `published !== false` → si el flag falta (catálogo viejo) no omite; si es false, omite
// el plato como línea (degrada: el cliente igual ve el Kit, ese plato no descuenta stock).
const dishPurchasable = d => !!d && !!d.variantId && d.status === 'ACTIVE' && !d.draft && d.published !== false;

/* ---- Unidad del kit = proteína + acomp1 + acomp2 (kits 'full'), o solo `protein`
   como selección única (kits 'single': Proteínas solas / Batidos). Se reutiliza la
   misma estructura; en 'single' acomp1/acomp2 quedan null. ---- */
const emptyMeal = () => ({
  protein: null,
  acomp1: null,
  acomp2: null
});
// shape-aware: 'single' → basta la selección única; 'full' → proteína + 2 acomp.
const mealDone = (m, shape) => !!m && !!m.protein && (shape === 'single' || !!m.acomp1 && !!m.acomp2);
// Variante por kit (resuelve el shape desde el catálogo). Evita pasar shape a mano.
const mealDoneK = (kit, m) => mealDone(m, shapeOf(kit));

/* Kit recomendado: rellena cada almuerzo con la 1ª opción SELECCIONABLE de su slot
   (rotando para dar variedad). Robusto al menú de cada kit. */
function buildReco(kit) {
  const n = sizeOf(kit).n;
  return Array.from({
    length: n
  }, (_, i) => {
    const menu = menuFor(kit, i);
    const pick = arr => {
      const ok = arr.map(dishById).filter(dishSelectable);
      return ok.length ? ok[i % ok.length].id : null;
    };
    return {
      protein: pick(menu.proteins),
      acomp1: pick(menu.acomp1),
      acomp2: pick(menu.acomp2)
    };
  });
}

/* Copia la selección de otra unidad al slot `slot`, PERO solo los platos que Redi
   dispuso para ESE slot. Los menús cambian de un almuerzo a otro (control de costo e
   inventario), así que copiar a ciegas metería en el almuerzo 3 un plato que solo estaba
   ofrecido en el 2: cocina recibiría comida no asignada a ese almuerzo y el webhook
   descontaría inventario de un producto que no tocaba. Lo que no encaja se deja vacío. */
function repetirEnSlot(kit, slot, origen) {
  const menu = menuFor(kit, slot);
  const listas = {
    protein: menu.proteins,
    acomp1: menu.acomp1,
    acomp2: menu.acomp2
  };
  const roles = shapeOf(kit) === 'single' ? ['protein'] : ['protein', 'acomp1', 'acomp2'];
  const out = emptyMeal();
  if (!origen) return out;
  roles.forEach(rol => {
    const id = origen[rol];
    if (id == null) return;
    if ((listas[rol] || []).indexOf(id) === -1) return; // no está en el menú de este slot
    if (!dishSelectable(dishById(id))) return; // draft / por crear
    out[rol] = id;
  });
  return out;
}
/* ¿Ofrecer "Repetir el anterior"? Solo si la copia deja la unidad COMPLETA.
   Redi cura un menú distinto por almuerzo precisamente para que no se repita: medido
   sobre el catálogo, las proteínas no coinciden entre almuerzos consecutivos en ningún
   kit de almuerzos. Un botón que copia media unidad promete un atajo y deja al cliente
   igual de a medias, así que en esos kits sencillamente no aparece. Donde sí tiene
   sentido (Batidos: los 3 sabores están en todos los slots) funciona entero. */
const repetirCompleta = (kit, slot, origen) => mealDoneK(kit, repetirEnSlot(kit, slot, origen));

/* ---- Add-ons (upsell): solo si el catálogo los trae ---- */
const RK_ADDONS = (RK_CATALOG.addons || []).map(a => ({
  ...a,
  id: String(a.id)
}));
Object.assign(window, {
  money,
  RK_CATALOG,
  RK_SIZES,
  sizeOf,
  shapeOf,
  RK_DISHES,
  DISH_BY,
  dishById,
  RK_MENUS,
  menuFor,
  emptyMeal,
  mealDone,
  mealDoneK,
  buildReco,
  RK_ADDONS,
  dishSelectable,
  dishPurchasable,
  repetirEnSlot,
  repetirCompleta
});

/* ===== rk-ui-live.jsx ===== */
/* Redi Food — "Armá tu kit" · primitivos de UI (versión conectada)
   Copia de rk-ui.jsx con DishPhoto consciente de imágenes reales del catálogo.
   El resto de primitivos son idénticos al prototipo aprobado. */

/* Pide al CDN de Shopify la foto ya redimensionada. Las URLs del catálogo vienen a
   resolución completa (los PNG de kit pesan ~600 KB) y con el rediseño hay 6 en la primera
   pantalla; sin esto el LCP se dispara. Si la URL no es del CDN, se devuelve tal cual. */
function imgAt(url, w) {
  if (!url || !/cdn\.shopify\.com/.test(url)) return url;
  return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
}

/* Desplaza `el` justo por debajo de la barra de pasos, que es sticky.
   `scrollIntoView` lo dejaba DEBAJO de esa barra: mide 143px en escritorio y se apoya
   sobre el header del theme, así que el título del paso quedaba tapado (verificado con
   navegador: título en y=120 con la barra ocupando 64→207). Un `scroll-margin-top` fijo
   no vale porque la altura de la barra cambia entre móvil y escritorio y el header del
   theme lo publica Dawn en tiempo de ejecución; aquí se mide lo que hay de verdad. */
function scrollBajoLaBarra(el, comportamiento) {
  if (!el || !el.getBoundingClientRect) return;
  const barra = document.querySelector('.rk-top');
  const tope = barra ? barra.getBoundingClientRect().bottom : 0;
  const y = window.pageYOffset + el.getBoundingClientRect().top - tope - 12;
  window.scrollTo({
    top: Math.max(0, y),
    behavior: comportamiento || 'smooth'
  });
}

/* Foto del plato: usa la imagen real del producto si existe; si no, el
   placeholder con tinte por categoría (igual que el prototipo). */
function DishPhoto({
  dish,
  h = 96
}) {
  const small = h <= 76;
  const img = dish && dish.image;
  // Si la imagen falla al cargar, caemos al placeholder (tinte + nombre).
  const [failed, setFailed] = React.useState(false);
  const showImg = img && !failed;
  return /*#__PURE__*/React.createElement("div", {
    className: `rk-photo rk-photo--${dish && dish.tone || 'amber'} ${small ? 'is-small' : ''} ${showImg ? 'has-img' : ''}`,
    style: {
      height: h
    }
  }, showImg && /*#__PURE__*/React.createElement("img", {
    className: "rk-photo__img",
    src: imgAt(img, 420),
    alt: dish && dish.name || '',
    loading: "lazy",
    onError: () => setFailed(true)
  }), !showImg && /*#__PURE__*/React.createElement("span", {
    className: "rk-photo__plate"
  }), !small && !showImg && dish && dish.name && /*#__PURE__*/React.createElement("span", {
    className: "rk-photo__ph"
  }, dish.name));
}

/* Stepper +/− neobrutalista. Estado 0 = botón "Agregar". */
function Stepper({
  qty,
  onAdd,
  onSub,
  disabledAdd,
  compact
}) {
  if (!qty) {
    return /*#__PURE__*/React.createElement("button", {
      className: `rk-add ${disabledAdd ? 'is-locked' : ''} ${compact ? 'is-compact' : ''}`,
      onClick: e => {
        e.stopPropagation();
        if (!disabledAdd) onAdd();
      },
      "aria-label": "Agregar al kit"
    }, /*#__PURE__*/React.createElement("span", {
      className: "rk-add__plus"
    }, "+"), !compact && /*#__PURE__*/React.createElement("span", null, "Agregar"));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: `rk-step ${compact ? 'is-compact' : ''}`,
    onClick: e => e.stopPropagation()
  }, /*#__PURE__*/React.createElement("button", {
    className: "rk-step__btn",
    onClick: onSub,
    "aria-label": "Quitar uno"
  }, "−"), /*#__PURE__*/React.createElement("span", {
    className: "rk-step__n"
  }, qty), /*#__PURE__*/React.createElement("button", {
    className: `rk-step__btn ${disabledAdd ? 'is-disabled' : ''}`,
    onClick: () => !disabledAdd && onAdd(),
    "aria-label": "Agregar uno"
  }, "+"));
}

/* Botón principal Redi (sombra apilada). */
function Btn({
  children,
  onClick,
  full,
  variant = 'green',
  size = 'lg',
  disabled,
  sub
}) {
  return /*#__PURE__*/React.createElement("button", {
    className: `rk-btn rk-btn--${variant} rk-btn--${size} ${full ? 'is-full' : ''} ${disabled ? 'is-disabled' : ''}`,
    onClick: () => !disabled && onClick && onClick(),
    disabled: disabled
  }, /*#__PURE__*/React.createElement("span", {
    className: "rk-btn__main"
  }, children), sub && /*#__PURE__*/React.createElement("span", {
    className: "rk-btn__sub"
  }, sub));
}

/* Encabezado del flujo: stepper de 3 círculos con líneas conectoras.
   Los pasos YA RECORRIDOS son clicables para volver; el actual y los futuros no (avanzar
   exige completar el paso, y dejarlos pulsables prometería un atajo que no existe).
   El botón "Volver" se mantiene solo en móvil vía CSS: los círculos son un blanco táctil
   pobre y ahí la flecha del navegador no está a mano. */
function TopBar({
  step,
  steps,
  onBack,
  onGo
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "rk-top"
  }, step > 0 && /*#__PURE__*/React.createElement("div", {
    className: "rk-top__row"
  }, /*#__PURE__*/React.createElement("button", {
    className: "rk-top__back",
    onClick: onBack,
    "aria-label": "Volver"
  }, /*#__PURE__*/React.createElement("span", {
    className: "rk-top__back-chev",
    "aria-hidden": "true"
  }, "‹"), /*#__PURE__*/React.createElement("span", {
    className: "rk-top__back-txt"
  }, "Volver"))), /*#__PURE__*/React.createElement("ol", {
    className: "rk-steps"
  }, steps.map((s, i) => {
    const hecho = i < step;
    const actual = i === step;
    return /*#__PURE__*/React.createElement("li", {
      key: s,
      className: `rk-steps__item ${actual ? 'is-on' : ''} ${hecho ? 'is-done' : ''}`
    }, i > 0 && /*#__PURE__*/React.createElement("span", {
      className: "rk-steps__line",
      "aria-hidden": "true"
    }), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "rk-steps__btn",
      onClick: () => hecho && onGo && onGo(i),
      disabled: !hecho,
      "aria-current": actual ? 'step' : undefined,
      "aria-label": `Paso ${i + 1}: ${s}`
    }, /*#__PURE__*/React.createElement("span", {
      className: "rk-steps__dot"
    }, hecho ? '✓' : i + 1), /*#__PURE__*/React.createElement("span", {
      className: "rk-steps__label"
    }, s)));
  })));
}

/* Modal de confirmación de salida: avisa que se perderá el kit en progreso.
   onStay = seguir armando (cierra) · onLeave = salir igual (navega de verdad). */
function ExitModal({
  onStay,
  onLeave
}) {
  const node = /*#__PURE__*/React.createElement("div", {
    className: "rk-modal-backdrop",
    onClick: onStay,
    role: "dialog",
    "aria-modal": "true",
    "aria-labelledby": "rk-exit-title"
  }, /*#__PURE__*/React.createElement("div", {
    className: "rk-modal",
    onClick: e => e.stopPropagation()
  }, /*#__PURE__*/React.createElement("h2", {
    id: "rk-exit-title",
    className: "rk-modal__title"
  }, "¿Salir de Arma tu kit?"), /*#__PURE__*/React.createElement("p", {
    className: "rk-modal__text"
  }, "Si sales ahora perderás los almuerzos que ya armaste. ¿Seguro?"), /*#__PURE__*/React.createElement("div", {
    className: "rk-modal__actions"
  }, /*#__PURE__*/React.createElement(Btn, {
    variant: "green",
    size: "lg",
    full: true,
    onClick: onStay
  }, "Seguir armando"), /*#__PURE__*/React.createElement("button", {
    className: "rk-btn rk-btn--ghost rk-btn--lg is-full",
    onClick: onLeave
  }, /*#__PURE__*/React.createElement("span", {
    className: "rk-btn__main"
  }, "Salir igual")))));
  // Portal al <body>: el backdrop fixed queda relativo al viewport real, no al
  // contenedor del wizard (max-width 540) — así el modal centra en cualquier ancho.
  return ReactDOM.createPortal && document.body ? ReactDOM.createPortal(node, document.body) : node;
}
Object.assign(window, {
  DishPhoto,
  Stepper,
  Btn,
  TopBar,
  ExitModal,
  imgAt,
  scrollBajoLaBarra
});

/* ===== rk-screens.jsx ===== */
/* Redi Food — "Armá tu kit" · pantallas del flujo
   Modelo: cada almuerzo = 1 proteína + 2 acompañamientos. */
const {
  useState: useStateS
} = React;

/* ============================================================
   PASO 0 — Tamaño del kit
   ============================================================ */
// Icono del chip móvil. Solo decorativo: el chip lleva su texto al lado.
const iconoKit = s => s.pick === 'batido' ? '🥤' : s.shape === 'single' ? '🍗' : s.premium ? '⭐' : s.n <= 5 ? '🍱' : s.n <= 7 ? '🍲' : '📦';

// Razones para confiar, al pie del paso 1. Fijas: no dependen del kit elegido.
const RK_TRUST = [{
  k: '+2.000',
  v: 'Redi Fans'
}, {
  k: '24-48 h',
  v: 'y lo tienes en casa'
}, {
  k: '15 min',
  v: 'y está en la mesa'
}, {
  k: 'Sin suscripción',
  v: 'pides cuando quieres'
}];
function SizeStep({
  kit,
  onPick
}) {
  const kits = window.RK_SIZES;
  return /*#__PURE__*/React.createElement("div", {
    className: "rk-screen"
  }, /*#__PURE__*/React.createElement("div", {
    className: "rk-h"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "rk-h__title"
  }, "¿Cuántos almuerzos", /*#__PURE__*/React.createElement("br", null), "quieres pedir?"), /*#__PURE__*/React.createElement("p", {
    className: "rk-h__sub"
  }, "Elige el tamaño de tu kit y arma cada almuerzo con la proteína y los 2 acompañamientos que prefieras. Llegan congelados y quedan listos en 15 minutos.")), /*#__PURE__*/React.createElement("div", {
    className: "rk-chips",
    role: "group",
    "aria-label": "Ir a un kit"
  }, kits.map(s => /*#__PURE__*/React.createElement("button", {
    key: s.key,
    className: `rk-chip ${s.key === kit ? 'is-on' : ''}`,
    onClick: () => onPick(s.key)
  }, /*#__PURE__*/React.createElement("span", {
    className: "rk-chip__ico",
    "aria-hidden": "true"
  }, iconoKit(s)), /*#__PURE__*/React.createElement("span", {
    className: "rk-chip__t"
  }, s.n, " ", (s.unit || {}).many), /*#__PURE__*/React.createElement("span", {
    className: "rk-chip__s"
  }, s.tagline)))), /*#__PURE__*/React.createElement("div", {
    className: "rk-sizes"
  }, kits.map(s => {
    const on = s.key === kit;
    const per = s.price / s.n;
    const ahorro = (s.compare || 0) - s.price;
    const pct = ahorro > 0 ? Math.round(ahorro / s.compare * 100) : 0;
    const unit = s.unit || {
      many: 'almuerzos'
    };
    return /*#__PURE__*/React.createElement("button", {
      key: s.key,
      className: `rk-size ${on ? 'is-on' : ''} ${s.premium ? 'rk-size--premium' : ''} ${s.popular ? 'rk-size--popular' : ''} ${s.shape === 'single' ? 'rk-size--single' : ''}`,
      onClick: () => onPick(s.key),
      "aria-pressed": on
    }, s.image && /*#__PURE__*/React.createElement("span", {
      className: "rk-size__photo"
    }, /*#__PURE__*/React.createElement("img", {
      className: "rk-size__img",
      src: window.imgAt(s.image, 800),
      alt: ""
      /* El kit destacado es lo primero que se mira: se carga ya. El resto
         espera a acercarse, para no pelear por ancho de banda con él. */,
      loading: s.popular ? 'eager' : 'lazy',
      decoding: "async"
    })), s.popular && /*#__PURE__*/React.createElement("span", {
      className: "rk-size__flag"
    }, "★ ", s.tagline), s.premium && /*#__PURE__*/React.createElement("span", {
      className: "rk-size__flag rk-size__flag--gold"
    }, "✦ ", s.label), /*#__PURE__*/React.createElement("span", {
      className: "rk-size__body"
    }, /*#__PURE__*/React.createElement("span", {
      className: "rk-size__radio",
      "aria-hidden": "true"
    }), /*#__PURE__*/React.createElement("span", {
      className: "rk-size__data"
    }, /*#__PURE__*/React.createElement("span", {
      className: "rk-size__row1"
    }, /*#__PURE__*/React.createElement("span", {
      className: "rk-size__nwrap"
    }, /*#__PURE__*/React.createElement("span", {
      className: "rk-size__n"
    }, s.n), /*#__PURE__*/React.createElement("span", {
      className: "rk-size__unit"
    }, unit.many)), /*#__PURE__*/React.createElement("span", {
      className: "rk-size__price"
    }, window.money(s.price))), /*#__PURE__*/React.createElement("span", {
      className: "rk-size__row2"
    }, /*#__PURE__*/React.createElement("span", {
      className: "rk-size__per"
    }, window.money(per), " c/u", !s.popular && /*#__PURE__*/React.createElement("em", null, " · ", s.tagline)), ahorro > 0 && /*#__PURE__*/React.createElement("span", {
      className: "rk-size__compare-wrap"
    }, /*#__PURE__*/React.createElement("s", {
      className: "rk-size__compare"
    }, window.money(s.compare)), /*#__PURE__*/React.createElement("span", {
      className: "rk-size__off"
    }, "−", pct, "%"))), ahorro > 0 && /*#__PURE__*/React.createElement("span", {
      className: "rk-size__save"
    }, "Ahorras ", window.money(ahorro)))));
  })), /*#__PURE__*/React.createElement("div", {
    className: "rk-trust"
  }, RK_TRUST.map(t => /*#__PURE__*/React.createElement("div", {
    key: t.k,
    className: "rk-trust__item"
  }, /*#__PURE__*/React.createElement("b", {
    className: "rk-trust__k"
  }, t.k), /*#__PURE__*/React.createElement("span", {
    className: "rk-trust__v"
  }, t.v)))));
}

/* ============================================================
   PASO 1 — Builder por almuerzo (proteína + 2 acompañamientos)
   ============================================================ */
/* Etiquetas de la tarjeta de plato, excluyentes entre sí y en esquinas distintas:
   · "Próximamente" (arriba-izq) — el plato no es elegible; manda sobre todo lo demás.
   · "Más pedido"   (arriba-izq) — prueba social curada (RK_CATALOG → dishes[].top).
   · check verde    (arriba-der) — ya elegido; entonces la etiqueta sobra y se retira,
     porque su trabajo era ayudar a decidir y la decisión ya está tomada. */
function OptionCard({
  opt,
  selected,
  onClick
}) {
  // Platos en borrador / por crear en inventario se muestran deshabilitados con
  // sello "Próximamente": visibles pero no seleccionables.
  const soon = !window.dishSelectable(opt);
  return /*#__PURE__*/React.createElement("button", {
    className: `rk-opt ${selected ? 'is-on' : ''} ${soon ? 'is-soon' : ''}`,
    onClick: soon ? undefined : onClick,
    disabled: soon,
    "aria-disabled": soon
  }, selected && /*#__PURE__*/React.createElement("span", {
    className: "rk-opt__check"
  }, "✓"), soon && /*#__PURE__*/React.createElement("span", {
    className: "rk-opt__badge rk-opt__badge--soon"
  }, "Próximamente"), opt.top && !soon && !selected && /*#__PURE__*/React.createElement("span", {
    className: "rk-opt__badge rk-opt__badge--top"
  }, "Más pedido"), /*#__PURE__*/React.createElement(DishPhoto, {
    dish: opt,
    h: 150
  }), /*#__PURE__*/React.createElement("span", {
    className: "rk-opt__name"
  }, opt.name));
}
function MealBuilder({
  kit,
  size,
  meals,
  active,
  phase,
  showReco,
  accent,
  onPick,
  onJump,
  onReco,
  onConfirmMeal,
  onRepeatPrev
}) {
  const sz = window.sizeOf(kit);
  const unit = sz.unit || {
    one: 'almuerzo',
    many: 'almuerzos',
    short: 'Alm.',
    build: 'Elige 1 proteína y 2 acompañamientos.'
  };
  const single = sz.shape === 'single';
  const cap = s => s.charAt(0).toUpperCase() + s.slice(1);
  const meal = meals[active] || window.emptyMeal();
  const allEmpty = meals.every(m => !m.protein && !m.acomp1 && !m.acomp2);
  const todoListo = meals.every(m => window.mealDoneK(kit, m));
  const mealReady = window.mealDoneK(kit, meal);
  // Menú curado de ESTA unidad (varía por kit y por slot)
  const menu = window.menuFor(kit, active);
  // kits 'single' → una sola fase (la selección única); 'full' → proteína + 2 acomp.
  const PHASES = single ? [{
    key: 'protein',
    step: cap(unit.one),
    ids: menu.proteins
  }] : [{
    key: 'protein',
    step: '1 · Proteína',
    ids: menu.proteins
  }, {
    key: 'acomp1',
    step: '2 · Acompañamiento 1',
    ids: menu.acomp1
  }, {
    key: 'acomp2',
    step: '3 · Acompañamiento 2',
    ids: menu.acomp2
  }];
  const labelFor = k => {
    const d = window.dishById(meal[k]);
    return d ? d.name : 'Elige 1';
  };
  // siguiente unidad incompleta (para el botón de confirmación manual)
  const seq = [...Array(size).keys()].filter(i => i !== active);
  const ordered = [...seq.filter(i => i > active), ...seq.filter(i => i < active)];
  const nextIdx = ordered.find(i => !window.mealDoneK(kit, meals[i]));
  // "Repetir el anterior" solo si algo del almuerzo previo cabe en el menú de ESTE
  // (los menús varían por slot). Si no sobrevive nada al filtro, el botón no aparece:
  // más vale no ofrecerlo que ofrecer un atajo que deja la unidad igual de vacía.
  const puedeRepetir = active > 0 && window.repetirCompleta(kit, active, meals[active - 1]);

  // Scroll automático:
  //  · al cambiar de almuerzo (confirmar / saltar) → arriba, para empezar desde el título.
  //  · al completar el almuerzo actual → al botón de confirmación.
  const confirmRef = React.useRef(null);
  const topRef = React.useRef(null);
  const prevActive = React.useRef(active);
  React.useEffect(() => {
    const changed = prevActive.current !== active;
    prevActive.current = active;
    if (changed) {
      if (topRef.current) window.scrollBajoLaBarra(topRef.current);
      return;
    }
    if (mealReady) {
      const el = confirmRef.current;
      if (el) el.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });else if (typeof window !== 'undefined') window.scrollTo({
        top: document.body.scrollHeight,
        behavior: 'smooth'
      });
    }
  }, [mealReady, active]);
  return /*#__PURE__*/React.createElement("div", {
    className: "rk-screen rk-screen--build"
  }, /*#__PURE__*/React.createElement("div", {
    className: "rk-build__head",
    ref: topRef
  }, /*#__PURE__*/React.createElement("div", {
    className: "rk-h rk-h--tight"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "rk-h__title"
  }, single ? `${cap(unit.one)} ${active + 1}` : `Arma tu almuerzo ${active + 1}`), /*#__PURE__*/React.createElement("p", {
    className: "rk-h__sub"
  }, unit.build)), puedeRepetir && /*#__PURE__*/React.createElement("button", {
    className: "rk-repeat",
    onClick: onRepeatPrev
  }, "Repetir el anterior")), /*#__PURE__*/React.createElement("div", {
    className: "rk-rail"
  }, meals.map((m, i) => {
    const done = window.mealDoneK(kit, m);
    const part = !done && (m.protein || m.acomp1 || m.acomp2);
    return /*#__PURE__*/React.createElement("button", {
      key: i,
      className: `rk-slot ${i === active ? 'is-on' : ''} ${done ? 'is-done' : ''} ${part ? 'is-part' : ''}`,
      onClick: () => onJump(i, single ? 'protein' : m.protein ? m.acomp1 ? 'acomp2' : 'acomp1' : 'protein')
    }, /*#__PURE__*/React.createElement("span", {
      className: "rk-slot__n"
    }, done ? '✓' : i + 1), /*#__PURE__*/React.createElement("span", {
      className: "rk-slot__lbl"
    }, unit.short, " ", i + 1));
  })), showReco && !todoListo && /*#__PURE__*/React.createElement("button", {
    className: `rk-reco rk-reco--${accent} ${allEmpty ? '' : 'rk-reco--slim'}`,
    onClick: onReco
  }, /*#__PURE__*/React.createElement("div", {
    className: "rk-reco__txt"
  }, /*#__PURE__*/React.createElement("span", {
    className: "rk-reco__k"
  }, "¿Sin tiempo? Te lo armamos nosotros"), /*#__PURE__*/React.createElement("span", {
    className: "rk-reco__d"
  }, "Armamos tus ", size, " ", unit.many, " con los combos más pedidos")), /*#__PURE__*/React.createElement("span", {
    className: "rk-reco__cta"
  }, "Cargar kit Redi")), !single && /*#__PURE__*/React.createElement("div", {
    className: "rk-phases rk-phases--3"
  }, PHASES.map(ph => /*#__PURE__*/React.createElement("button", {
    key: ph.key,
    className: `rk-phase ${phase === ph.key ? 'is-on' : ''}`,
    onClick: () => onJump(active, ph.key)
  }, /*#__PURE__*/React.createElement("span", {
    className: "rk-phase__step"
  }, ph.step), /*#__PURE__*/React.createElement("span", {
    className: "rk-phase__v"
  }, labelFor(ph.key))))), /*#__PURE__*/React.createElement("div", {
    className: "rk-opts"
  }, (PHASES.find(p => p.key === phase) || PHASES[0]).ids.map(id => {
    const d = window.dishById(id);
    if (!d) return null;
    return /*#__PURE__*/React.createElement(OptionCard, {
      key: id,
      opt: d,
      selected: meal[phase] === id,
      onClick: () => onPick(phase, id)
    });
  })), mealReady && nextIdx !== undefined && /*#__PURE__*/React.createElement("button", {
    className: "rk-confirm",
    ref: confirmRef,
    onClick: onConfirmMeal
  }, /*#__PURE__*/React.createElement("span", {
    className: "rk-confirm__main"
  }, "Confirmar ", unit.one, " ", active + 1), /*#__PURE__*/React.createElement("span", {
    className: "rk-confirm__sub"
  }, "Seguir con ", unit.art, " ", unit.one, " ", nextIdx + 1, " ›")));
}

/* ============================================================
   PASO 2 — Extras / add-ons (upsell)
   ============================================================ */
/* ============================================================
   PASO 3 — Resumen
   ============================================================ */
function SummaryStep({
  kit,
  size,
  meals,
  onEditMeal
}) {
  const sz = window.sizeOf(kit);
  const unit = sz.unit || {
    one: 'almuerzo',
    many: 'almuerzos'
  };
  // Sin extras ni suscripción: ambos se retiraron del producto. El total es el precio del
  // kit, y el ahorro sale del precio tachado del kit padre (0 si no hay comparativo).
  const saved = Math.max(0, (sz.compare || 0) - sz.price);
  return /*#__PURE__*/React.createElement("div", {
    className: "rk-screen"
  }, /*#__PURE__*/React.createElement("div", {
    className: "rk-h rk-h--tight"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "rk-h__title"
  }, "Revisa tu kit"), /*#__PURE__*/React.createElement("p", {
    className: "rk-h__sub"
  }, size, " ", unit.many, " · toca \"Editar\" para cambiar cualquiera.")), /*#__PURE__*/React.createElement("div", {
    className: "rk-sum"
  }, meals.map((m, i) => {
    const prot = (window.dishById(m.protein) || {}).name || '—';
    const sides = [m.acomp1, m.acomp2].map(id => (window.dishById(id) || {}).name).filter(Boolean).join(' + ');
    return /*#__PURE__*/React.createElement("div", {
      key: i,
      className: "rk-mline"
    }, /*#__PURE__*/React.createElement("span", {
      className: "rk-mline__n"
    }, i + 1), /*#__PURE__*/React.createElement("span", {
      className: "rk-mline__txt"
    }, /*#__PURE__*/React.createElement("strong", null, prot), sides ? /*#__PURE__*/React.createElement("span", {
      className: "rk-mline__sides"
    }, " · ", sides) : null), /*#__PURE__*/React.createElement("button", {
      className: "rk-mline__edit",
      onClick: () => onEditMeal(i)
    }, "Editar"));
  })), /*#__PURE__*/React.createElement("div", {
    className: "rk-totals"
  }, /*#__PURE__*/React.createElement("div", {
    className: "rk-totals__row"
  }, /*#__PURE__*/React.createElement("span", null, "Kit ", size, " ", unit.many), /*#__PURE__*/React.createElement("span", null, window.money(sz.price))), /*#__PURE__*/React.createElement("div", {
    className: "rk-totals__row is-grand"
  }, /*#__PURE__*/React.createElement("span", null, "Total"), /*#__PURE__*/React.createElement("span", null, window.money(sz.price))), saved > 0 && /*#__PURE__*/React.createElement("div", {
    className: "rk-totals__saved"
  }, "Estás ahorrando ", window.money(saved))));
}

/* ============================================================
   Barra inferior pegajosa (progreso + total + CTA)
   ============================================================ */
function BottomBar({
  step,
  size,
  done,
  price,
  cta,
  onNext,
  locked,
  hint,
  noun,
  sub
}) {
  const pct = Math.min(100, done / size * 100);
  const isBuild = step === 1;
  return /*#__PURE__*/React.createElement("div", {
    className: "rk-bottom"
  }, isBuild && /*#__PURE__*/React.createElement("div", {
    className: "rk-progress"
  }, /*#__PURE__*/React.createElement("div", {
    className: "rk-progress__txt"
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("strong", null, done, " de ", size), " ", noun || 'almuerzos', " listos"), /*#__PURE__*/React.createElement("span", {
    className: "rk-progress__hint"
  }, hint)), /*#__PURE__*/React.createElement("div", {
    className: "rk-progress__track"
  }, /*#__PURE__*/React.createElement("span", {
    className: "rk-progress__fill",
    style: {
      width: pct + '%'
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "rk-bottom__row"
  }, price != null && /*#__PURE__*/React.createElement("div", {
    className: "rk-bottom__price"
  }, /*#__PURE__*/React.createElement("span", {
    className: "rk-bottom__price-n"
  }, window.money(price)), sub && /*#__PURE__*/React.createElement("span", {
    className: "rk-bottom__price-l"
  }, sub)), /*#__PURE__*/React.createElement(Btn, {
    onClick: onNext,
    disabled: locked,
    full: price == null,
    size: "lg"
  }, cta)));
}
Object.assign(window, {
  SizeStep,
  MealBuilder,
  SummaryStep,
  BottomBar
});

/* ===== rk-cart.jsx ===== */
/* Redi Food — "Armá tu kit" · puente al carrito nativo de Shopify
   Modelo Opción C (inventario unificado, sin productos $0):
   - 1 línea = producto KIT con precio → cobra el precio del kit (carrito limpio).
   - La composición viaja en line item properties prefijadas con "_" (ocultas):
       · lista legible por unidad ("Almuerzo 1", "Proteína 1"…) para fulfillment.
       · `_kit_components` = variantes de los PRODUCTOS INDIVIDUALES REALES elegidos.
   - El descuento de inventario lo hace una automatización post-orden (webhook
     orders/create) que lee `_kit_components` y resta 1 de cada producto individual.
     Así NO se necesitan líneas $0 ni publicar componentes al Online Store. */

function rkUuid() {
  // sin Date.now()/Math.random críticos: combina performance.now + contador
  const c = rkUuid._c = (rkUuid._c || 0) + 1;
  const t = typeof performance !== 'undefined' ? performance.now() : 0;
  return 'kit-' + Math.floor(t).toString(36) + '-' + c.toString(36);
}

/* Modo de carrito (conmutable sin reescribir):
   · 'kit-only'         → al carrito va SOLO la línea del Kit (con la composición
                          completa en line item properties para fulfillment). El
                          usuario ve únicamente el item del Kit. No descuenta stock
                          por plato. Es el modo del piloto/beta (los componentes $0
                          aún no están publicados al canal Online Store).
   · 'kit+components'   → además agrega 1 línea $0 por plato (descuenta inventario
                          por componente). REQUIERE: (a) los 40 productos componente
                          publicados al Online Store, y (b) ocultar esas líneas $0 en
                          la plantilla de carrito del theme (van marcadas con
                          propiedades `_…` y precio $0) para que el usuario siga viendo
                          solo el Kit. Activar cuando Redi publique los componentes. */
const CART_MODE = typeof window !== 'undefined' && window.RK_CART_MODE || 'kit-only';

/* Construye el payload de /cart/add.js a partir del estado del wizard.
   Devuelve { items, missingSides, kitDraft, summary, mode } */
function buildCartPayload(state) {
  const {
    kit,
    meals,
    addons
  } = state;
  const sz = window.sizeOf(kit);
  const unit = sz.unit || {
    one: 'almuerzo'
  };
  const cap = s => s.charAt(0).toUpperCase() + s.slice(1);
  const n = sz.n;
  const kitId = rkUuid();
  const items = [];
  const missingSides = [];
  const decrementIds = []; // variantes de productos individuales reales a descontar (Opción C)

  // Resumen legible por unidad. full: proteína + 2 acomp; single: solo la selección.
  const lines = meals.map((m, i) => {
    const prot = window.dishById(m.protein);
    const sd = [m.acomp1, m.acomp2].map(id => (window.dishById(id) || {}).name).filter(Boolean);
    return `${cap(unit.one)} ${i + 1}: ${prot ? prot.name : '—'}${sd.length ? ' + ' + sd.join(' + ') : ''}`;
  });
  const summary = lines.join(' | ');

  // Recolecta las variantes de los PRODUCTOS INDIVIDUALES REALES de cada unidad
  // (Opción C). El webhook orders/create descuenta 1 de cada una. Incluye proteína +
  // acomp (full) o la selección única (single). decrementVariantId apunta al producto
  // individual real (fallback a variantId). Los draft/"Próximamente" no se incluyen.
  meals.forEach(m => {
    [m.protein, m.acomp1, m.acomp2].forEach(id => {
      const d = window.dishById(id);
      if (d && window.dishSelectable(d)) {
        const vid = d.decrementVariantId || d.variantId;
        if (vid) decrementIds.push(vid);
      }
    });
  });

  // 1) Kit padre (precio) — única línea visible. Lleva la lista por unidad (fulfillment,
  //    una fila por unidad, escaneable) y, oculto, `_kit_components` con las variantes a
  //    descontar para la automatización post-orden.
  const kitProps = {};
  lines.forEach((l, i) => {
    kitProps[`${cap(unit.one)} ${i + 1}`] = l.replace(/^[^:]+:\s*/, '');
  });
  if (decrementIds.length) kitProps._kit_components = decrementIds.join(',');
  items.push({
    id: sz.kitVariantId,
    quantity: 1,
    properties: kitProps
  });

  // 2) Componentes por almuerzo (solo en modo 'kit+components'): 1 proteína + 2
  //    acompañamientos como variantes $0. Solo se emite la línea si el plato es
  //    COMPRABLE; un componente inexistente/draft rompería TODO el lote atómico de
  //    /cart/add.js, así que se omite (va a missingSides).
  if (CART_MODE === 'kit+components') {
    meals.forEach((m, i) => {
      [['proteína', m.protein], ['acompañamiento', m.acomp1], ['acompañamiento', m.acomp2]].forEach(([rol, id]) => {
        const d = window.dishById(id);
        if (window.dishPurchasable(d)) {
          items.push({
            id: d.variantId,
            quantity: 1,
            properties: {
              _kit_id: kitId,
              _slot: `Almuerzo ${i + 1}`,
              _rol: rol,
              _nombre: d.name
            }
          });
        } else if (d) {
          missingSides.push(d.name); // componente sin SKU / draft / no publicado — no se incluye
        }
      });
    });
  }

  // 3) Extras (addons) — variantes reales con precio
  Object.entries(addons || {}).forEach(([id, qty]) => {
    const a = (window.RK_ADDONS || []).find(x => String(x.id) === String(id));
    if (a && a.variantId && qty > 0) items.push({
      id: a.variantId,
      quantity: qty
    });
  });
  return {
    items,
    missingSides,
    kitDraft: !!sz.kitDraft,
    summary,
    mode: CART_MODE
  };
}

/* Repinta el contador del carrito del header sin recargar la página.
   Desde el rediseño el wizard ya NO navega a /cart tras añadir (muestra la pantalla de
   confirmación), así que el icono se quedaría con el número viejo. Shopify devuelve la
   section ya renderizada si se le pide en el POST; `cart-icon-bubble` genera justo el
   interior del <a id="cart-icon-bubble"> del header, así que basta con sustituirlo.
   Si algo falla, se ignora: un contador desfasado no debe romper una compra hecha. */
function refrescarContadorCarrito(sections) {
  try {
    const html = sections && sections['cart-icon-bubble'];
    const destino = document.getElementById('cart-icon-bubble');
    if (!html || !destino) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const nuevo = doc.getElementById('shopify-section-cart-icon-bubble');
    if (nuevo) destino.innerHTML = nuevo.innerHTML;
  } catch (e) {/* el contador se pondrá al día en la siguiente navegación */}
}

/* Ejecuta el add-to-cart real contra Shopify.
   En modo demo (window.RK_DEMO) NO llama a Shopify: muestra el payload. */
async function addToCart(state) {
  const payload = buildCartPayload(state);
  if (window.RK_DEMO) {
    return {
      ok: true,
      demo: true,
      ...payload
    };
  }
  if (payload.kitDraft) {
    return {
      ok: false,
      reason: 'kit-draft',
      ...payload,
      message: 'El producto Kit aún está en borrador (draft). Publícalo para poder cobrarlo.'
    };
  }
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      // `sections` pide de paso el HTML del contador del header ya actualizado.
      body: JSON.stringify({
        items: payload.items,
        sections: 'cart-icon-bubble'
      })
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      return {
        ok: false,
        reason: 'cart-error',
        message: err.description || err.message || 'Error al agregar al carrito',
        ...payload
      };
    }
    const data = await res.json().catch(() => ({}));
    refrescarContadorCarrito(data && data.sections);
    return {
      ok: true,
      ...payload
    };
  } catch (e) {
    return {
      ok: false,
      reason: 'network',
      message: String(e),
      ...payload
    };
  }
}
Object.assign(window, {
  buildCartPayload,
  addToCart,
  rkUuid
});

/* ===== rk-app.jsx ===== */
/* Redi Food — "Armá tu kit" · App conectada (sin iPhone, sin tweaks, sin
   suscripción). Flujo: Tamaño → Almuerzos → Resumen → (Agregar al carrito) → Done.
   Reutiliza las pantallas del prototipo (rk-screens.jsx) tal cual. */
const {
  useState
} = React;
const newMeals = n => Array.from({
  length: n
}, () => window.emptyMeal());

/* Analytics — dispara CustomEvents que escucha flamel-datalayer-events.js
   (kit_builder_start / add_item / remove_item / complete / abandon + step). */
const fireKit = (name, detail) => {
  try {
    document.dispatchEvent(new CustomEvent('flamel:kit:' + name, {
      detail: detail || {}
    }));
  } catch (e) {}
};
const DEFAULT_KIT = (window.RK_SIZES.find(s => s.popular) || window.RK_SIZES[1] || window.RK_SIZES[0] || {
  key: '7',
  n: 7
}).key;

/* ===== Precarga "Repetir mi kit" — ?repetir=<variantes>&kv=<variante del kit> =====

   Los emails de reposición enlazan aquí con la composición del último pedido del
   cliente: `repetir` son las variantes que este mismo wizard guardó en la propiedad
   `_kit_components` (proteína + acompañamiento 1 + acompañamiento 2 por unidad, en ese
   orden; una sola por unidad en los kits 'single'), y `kv` es la variante del kit padre.

   POR QUÉ NO ES UN PERMALINK DE CARRITO: Shopify responde 422 y deja el carrito vacío
   ante cualquier permalink con line item properties (verificado contra redifood.co el
   2026-08-05). Sin esas propiedades el pedido llegaría sin platos elegidos y sin
   `_kit_components`, así que fulfillment no sabría qué empacar y el webhook orders/create
   no tendría nada que descontar. Por eso el enlace trae la composición y la reconstruye
   el wizard, que es quien sabe emitir el /cart/add.js correcto.

   DEGRADA A PROPÓSITO: sin parámetros, con parámetros ilegibles o con un `kv` que no
   corresponda a ningún kit, el wizard abre como siempre. Y un plato que ya no esté en
   carta deja su hueco VACÍO y se avisa — nunca se sustituye por otro a espaldas del
   cliente, que recibiría comida que no pidió. */

// Índice variante → plato. `_kit_components` guarda `decrementVariantId` cuando existe,
// así que se indexan ambas para poder resolver pedidos viejos y nuevos.
const DISH_BY_VARIANT = (() => {
  const idx = {};
  Object.keys(RK_DISHES).forEach(k => {
    const d = RK_DISHES[k];
    if (!d) return;
    [d.decrementVariantId, d.variantId].forEach(v => {
      if (v != null && !idx[String(v)]) idx[String(v)] = d;
    });
  });
  return idx;
})();
const avisoNoDisponibles = k => k === 1 ? 'Uno de los platos de tu kit anterior ya no está en carta. Te dejamos el resto puesto: elige con qué reemplazarlo.' : `${k} platos de tu kit anterior ya no están en carta. Te dejamos el resto puesto: elige con qué reemplazarlos.`;
function leerPrecarga() {
  const params = new URLSearchParams(window.location.search);
  const crudo = params.get('repetir');
  if (!crudo) return null;
  const variantes = crudo.split(',').map(s => s.trim()).filter(Boolean);
  if (!variantes.length) return null;

  // El kit lo fija `kv`. Sin él no se sabe si son 3 platos por unidad o 1, y adivinarlo
  // mal armaría un kit equivocado: mejor ignorar la precarga que reconstruirla torcida.
  const kv = params.get('kv');
  const size = kv && RK_SIZES.find(s => String(s.kitVariantId) === String(kv));
  if (!size) return null;
  const porUnidad = size.shape === 'single' ? 1 : 3;
  const campos = porUnidad === 1 ? ['protein'] : ['protein', 'acomp1', 'acomp2'];
  const meals = [];
  let noDisponibles = 0;
  for (let i = 0; i < size.n; i++) {
    const unidad = emptyMeal();
    campos.forEach((campo, j) => {
      const vid = variantes[i * porUnidad + j];
      if (vid === undefined) return; // el enlace trae menos platos de los que pide el kit
      const plato = DISH_BY_VARIANT[String(vid)];
      if (plato && dishSelectable(plato)) unidad[campo] = plato.id;else noDisponibles++;
    });
    meals.push(unidad);
  }
  const completas = meals.filter(m => mealDone(m, size.shape)).length;
  const primeraCoja = meals.findIndex(m => !mealDone(m, size.shape));
  return {
    kit: size.key,
    meals,
    noDisponibles,
    // Kit entero recuperado → directo al resumen: el valor está en "esto es lo que
    // pediste, cámbialo si quieres". Si falta algo, al armador y en la unidad coja.
    step: completas === size.n ? 2 : 1,
    active: primeraCoja === -1 ? 0 : primeraCoja
  };
}
const PRECARGA = (() => {
  try {
    return leerPrecarga();
  } catch (e) {
    return null; // ante cualquier sorpresa del enlace, wizard normal
  }
})();
function App() {
  // `kit` = id del kit elegido ('5','7','14','premium'); `n` = nº de almuerzos.
  const [kit, setKit] = useState(PRECARGA ? PRECARGA.kit : DEFAULT_KIT);
  const [meals, setMeals] = useState(() => PRECARGA ? PRECARGA.meals : newMeals(window.sizeOf(DEFAULT_KIT).n));
  const [active, setActive] = useState(PRECARGA ? PRECARGA.active : 0);
  const [phase, setPhase] = useState('protein'); // 'protein' | 'sides'
  const [addons, setAddons] = useState({});
  // 0 size · 1 build · 2 summary · 3 done. Con precarga se entra ya armado.
  const [step, setStep] = useState(PRECARGA ? PRECARGA.step : 0);
  const [flash, setFlash] = useState(PRECARGA && PRECARGA.noDisponibles ? avisoNoDisponibles(PRECARGA.noDisponibles) : null);
  const [result, setResult] = useState(null);
  const [showExit, setShowExit] = useState(false); // modal "¿Salir de Armá tu kit?"
  const kitStarted = React.useRef(false);
  const sentinelPushed = React.useRef(false); // ¿hay entrada de historial centinela activa?
  const leavingRef = React.useRef(false); // el usuario confirmó salir → no interceptar

  const sz = window.sizeOf(kit);
  const n = sz.n;
  const completed = meals.filter(m => window.mealDoneK(kit, m)).length;
  const kitComplete = completed === n;
  // Hay algo que perder: ya eligió platos y aún no terminó (step 3 = kit agregado).
  const hasProgress = step < 3 && meals.some(m => m.protein || m.acomp1 || m.acomp2);

  // El aviso de "platos que ya no están" deja de tener sentido en cuanto el cliente
  // rellena los huecos. Solo se dispara al completarse el kit, así que no pisa el
  // mensaje de error del carrito (que aparece con el kit ya completo).
  React.useEffect(() => {
    if (kitComplete) setFlash(null);
  }, [kitComplete]);

  // Al cambiar de paso (tamaño → almuerzos → resumen → listo), empezar desde arriba.
  // Excepción: si se entró con un kit precargado, el primer render NO desplaza. Este
  // scroll deja el encabezado del paso arriba del todo, y al hacerlo esconde el aviso de
  // "platos que ya no están" debajo de la barra sticky — justo el mensaje que el cliente
  // necesita leer nada más llegar desde el email.
  const scrollHecho = React.useRef(false);
  React.useEffect(() => {
    if (PRECARGA && !scrollHecho.current) {
      scrollHecho.current = true;
      return;
    }
    scrollHecho.current = true;
    const h = document.querySelector('.rk-scroll .rk-h');
    if (h) window.scrollBajoLaBarra(h);else window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, [step]);

  // Sub-pasos del almuerzo: proteína → acompañamiento 1 → acompañamiento 2.
  const PHASE_ORDER = ['protein', 'acomp1', 'acomp2'];
  const pick = (ph, id) => {
    // Ignorar selección de platos en borrador / por crear: no deben entrar al kit.
    if (!window.dishSelectable(window.dishById(id))) return;
    setMeals(ms => ms.map((m, i) => i === active ? {
      ...m,
      [ph]: id
    } : m));
    // kits 'full': avanzar al siguiente sub-paso (proteína → acomp1 → acomp2).
    // kits 'single': hay una sola selección → no hay sub-paso siguiente.
    if (sz.shape !== 'single') {
      const after = {
        ...meals[active],
        [ph]: id
      };
      const idx = PHASE_ORDER.indexOf(ph);
      // siguiente sub-paso vacío DESPUÉS del actual (no el primero vacío, para no saltar atrás
      // al editar fuera de orden); si no queda ninguno por delante, cae al hueco restante.
      const nextPhase = PHASE_ORDER.slice(idx + 1).find(p => !after[p]) || PHASE_ORDER.find(p => !after[p]);
      if (nextPhase) setPhase(nextPhase);
    }
    fireKit('add', {
      item: {
        id,
        type: ph
      },
      total: sz.price
    });
  };
  // Confirmación manual (reemplaza el auto-avance): salta al siguiente almuerzo incompleto.
  const nextIncomplete = () => {
    const seq = [...Array(n).keys()].filter(i => i !== active);
    const ordered = [...seq.filter(i => i > active), ...seq.filter(i => i < active)];
    return ordered.find(i => !window.mealDoneK(kit, meals[i]));
  };
  const confirmMeal = () => {
    const nxt = nextIncomplete();
    if (nxt !== undefined) {
      setActive(nxt);
      setPhase('protein');
    }
  };
  const jump = (i, ph) => {
    setActive(i);
    setPhase(ph || 'protein');
  };
  // Copia el almuerzo anterior, pero solo lo que el menú de ESTA unidad admite
  // (los menús cambian por slot). Deja el foco en el primer hueco que quede.
  const repeatPrev = () => {
    if (active === 0) return;
    const copia = window.repetirEnSlot(kit, active, meals[active - 1]);
    setMeals(ms => ms.map((m, i) => i === active ? copia : m));
    const orden = sz.shape === 'single' ? ['protein'] : PHASE_ORDER;
    setPhase(orden.find(p => !copia[p]) || orden[orden.length - 1]);
  };
  const loadReco = () => {
    setMeals(window.buildReco(kit));
    setActive(0);
    setPhase('protein');
  };
  const editMeal = i => {
    setStep(1);
    setActive(i);
    setPhase('protein');
  };
  // Al cambiar de kit, los menús por slot cambian → reinicia la selección.
  const changeKit = k => {
    setKit(k);
    setMeals(newMeals(window.sizeOf(k).n));
    setActive(0);
    setPhase('protein');
  };
  const grand = sz.price;
  const steps = ['Tamaño', 'Almuerzos', 'Resumen'];

  // Analytics: inicio del paso a paso (al entrar al builder) + cambio de paso
  // (kit_step alimenta el desglose de abandonos por paso del funnel).
  React.useEffect(() => {
    if (step >= 1 && step <= 2 && !kitStarted.current) {
      kitStarted.current = true;
      fireKit('start', {
        kit_type: 'almuerzos',
        kit,
        size: n
      });
    }
    fireKit('step', {
      step,
      step_name: steps[step] || ''
    });
  }, [step]);

  // Guard de salida (1/2): mientras haya progreso, mantener un centinela en el
  // historial para poder interceptar la flecha "atrás" del navegador.
  React.useEffect(() => {
    if (hasProgress && !sentinelPushed.current) {
      sentinelPushed.current = true;
      try {
        history.pushState({
          rkGuard: true
        }, '');
      } catch (e) {}
    } else if (!hasProgress && sentinelPushed.current) {
      sentinelPushed.current = false; // kit terminado o reseteado → desarmar
    }
  }, [hasProgress]);

  // Guard de salida (2/2): flecha atrás → modal de marca; recarga/cierre → diálogo nativo.
  React.useEffect(() => {
    const onPop = () => {
      if (!sentinelPushed.current || leavingRef.current) return; // dejar salir
      try {
        history.pushState({
          rkGuard: true
        }, '');
      } catch (e) {} // re-arma: no navega aún
      setShowExit(true);
    };
    const onBeforeUnload = e => {
      if (!sentinelPushed.current || leavingRef.current) return;
      e.preventDefault();
      e.returnValue = '';
      return '';
    };
    window.addEventListener('popstate', onPop);
    window.addEventListener('beforeunload', onBeforeUnload);
    return () => {
      window.removeEventListener('popstate', onPop);
      window.removeEventListener('beforeunload', onBeforeUnload);
    };
  }, []);
  const stayBuilding = () => setShowExit(false);
  const confirmLeave = () => {
    leavingRef.current = true;
    setShowExit(false);
    fireKit('abandon', {
      kit,
      size: n,
      completed
    });
    // Saltar el centinela (+ la entrada propia de la página) para salir de verdad.
    try {
      history.go(-2);
    } catch (e) {
      try {
        history.back();
      } catch (e2) {}
    }
  };
  const back = () => setStep(s => Math.max(0, s - 1));
  const next = () => setStep(s => s + 1);
  // Solo hacia atrás: avanzar exige completar el paso, y un stepper que deja saltar
  // adelante promete un atajo que el flujo no tiene.
  const goStep = i => {
    if (i < step) setStep(i);
  };
  const reset = () => {
    setStep(0);
    setMeals(newMeals(n));
    setActive(0);
    setPhase('protein');
    setAddons({});
    setResult(null);
    setFlash(null);
    // "Armar otro kit" empieza un kit de cero, así que hay que deshacer los dos
    // estados que dejó el add-to-cart anterior:
    leavingRef.current = false; // (1) re-armar el guard de salida; si no, el 2º kit
    //     se pierde con la flecha "atrás" sin avisar (el guard existe justo por eso).
    kitStarted.current = false; // (2) el 2º kit cuenta como un start propio; si no,
    //     GA4 registra 1 start y 2 complete y el embudo por eventos queda torcido.
  };
  const onAddToCart = async () => {
    leavingRef.current = true; // navegación intencional al carrito → no disparar el diálogo nativo
    const r = await window.addToCart({
      kit,
      meals,
      addons
    });
    setResult(r);
    if (r.ok) {
      fireKit('complete', {
        total: grand,
        items: r.items || [],
        kit,
        size: n
      });
      setStep(3);
    } else {
      leavingRef.current = false; // falló (draft/cart-error/red): re-armar el guard, no perder progreso
      setFlash(r.message || 'No se pudo agregar al carrito');
    }
  };

  // El ahorro acompaña al precio en toda la barra: es el argumento del kit frente a
  // comprar plato a plato, y es lo que justifica el importe que se ve al lado.
  const ahorro = Math.max(0, (sz.compare || 0) - sz.price);
  const subAhorro = ahorro > 0 ? `Ahorras ${window.money(ahorro)}` : null;
  let bottom;
  if (step === 0) bottom = {
    price: sz.price,
    sub: subAhorro,
    cta: `Armar mi kit de ${n} ${sz.unit.many}`,
    onNext: next,
    locked: false
  };else if (step === 1) bottom = {
    price: sz.price,
    sub: subAhorro,
    cta: kitComplete ? 'Ver resumen' : 'Continuar',
    onNext: next,
    locked: !kitComplete,
    hint: kitComplete ? '¡Todo listo!' : `Vas en el ${active + 1}`
  };else bottom = {
    price: grand,
    sub: subAhorro,
    cta: 'Agregar al carrito',
    onNext: onAddToCart,
    locked: false
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "rk-wrap"
  }, /*#__PURE__*/React.createElement("div", {
    className: "rk-app"
  }, step < 3 && /*#__PURE__*/React.createElement(TopBar, {
    step: step,
    steps: steps,
    onBack: back,
    onGo: goStep
  }), flash && /*#__PURE__*/React.createElement("div", {
    className: "rk-flash",
    role: "status"
  }, flash), /*#__PURE__*/React.createElement("div", {
    className: "rk-scroll",
    key: step
  }, step === 0 && /*#__PURE__*/React.createElement(SizeStep, {
    kit: kit,
    onPick: changeKit
  }), step === 1 && /*#__PURE__*/React.createElement(MealBuilder, {
    kit: kit,
    size: n,
    meals: meals,
    active: active,
    phase: phase,
    showReco: true,
    accent: "purple",
    onPick: pick,
    onJump: jump,
    onReco: loadReco,
    onConfirmMeal: confirmMeal,
    onRepeatPrev: repeatPrev
  }), step === 2 && /*#__PURE__*/React.createElement(SummaryStep, {
    kit: kit,
    size: n,
    meals: meals,
    onEditMeal: editMeal
  }), step === 3 && /*#__PURE__*/React.createElement(DonePane, {
    size: n,
    result: result,
    onReset: reset
  })), step < 3 && /*#__PURE__*/React.createElement(BottomBar, {
    step: step === 2 ? 3 : step,
    size: n,
    done: completed,
    noun: sz.unit.many,
    ...bottom
  })), showExit && /*#__PURE__*/React.createElement(ExitModal, {
    onStay: stayBuilding,
    onLeave: confirmLeave
  }));
}

/* Confirmación: en modo demo muestra el payload real que iría a /cart/add.js */
function DonePane({
  size,
  result,
  onReset
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "rk-screen rk-done"
  }, /*#__PURE__*/React.createElement("div", {
    className: "rk-done__badge"
  }, "✓"), /*#__PURE__*/React.createElement("h1", {
    className: "rk-done__title"
  }, result && result.demo ? 'Kit listo (demo)' : '¡Tu kit está en el carrito!'), /*#__PURE__*/React.createElement("p", {
    className: "rk-done__sub"
  }, result && result.demo ? 'En la tienda real, esto agrega el kit + sus componentes al carrito nativo de Shopify y sigue al checkout normal.' : 'Te llega congelado en 24-48 horas. Cada plato queda listo en 15 minutos.'), !(result && result.demo) && /*#__PURE__*/React.createElement("div", {
    className: "rk-done__actions"
  }, /*#__PURE__*/React.createElement("button", {
    className: "rk-btn rk-btn--ghost rk-btn--lg",
    onClick: onReset
  }, /*#__PURE__*/React.createElement("span", {
    className: "rk-btn__main"
  }, "Armar otro kit")), /*#__PURE__*/React.createElement(Btn, {
    size: "lg",
    onClick: () => {
      window.location.href = '/cart';
    }
  }, "Ir a pagar")), result && result.summary && /*#__PURE__*/React.createElement("div", {
    className: "rk-done__card",
    style: {
      marginBottom: 14
    }
  }, result.summary.split(' | ').map((l, i) => /*#__PURE__*/React.createElement("div", {
    key: i,
    className: "rk-done__line"
  }, /*#__PURE__*/React.createElement("span", null, l)))), result && result.demo && /*#__PURE__*/React.createElement("div", {
    style: {
      textAlign: 'left'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "rf-p3",
    style: {
      margin: '0 0 6px',
      fontWeight: 700,
      color: 'var(--green-forest)'
    }
  }, "POST /cart/add.js → items[]"), /*#__PURE__*/React.createElement("pre", {
    style: {
      background: '#0E3D0E',
      color: '#DCEFD6',
      padding: 12,
      borderRadius: 12,
      fontSize: 10,
      overflow: 'auto',
      maxHeight: 240
    }
  }, JSON.stringify({
    items: result.items
  }, null, 2)), result.missingSides && result.missingSides.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "rk-flash",
    style: {
      margin: '10px 0 0'
    }
  }, /*#__PURE__*/React.createElement("strong", null, result.missingSides.length, " acompañamientos"), " aún sin SKU — no se incluyen como línea hasta crearlos.")));
}
ReactDOM.createRoot(document.getElementById('rk-root') || document.getElementById('root')).render(/*#__PURE__*/React.createElement(App, null));

})();
